import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
    const token = sessionStorage.getItem("authToken"); // ✅ Check sessionStorage instead of localStorage
    return token ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
